<template>
  <div class="grid grid-cols-2">
    <symbol-progress-component :symbol="symbols.symbol_1" :volumeIsUndefined="volumeIsUndefined" />
    <symbol-progress-component :symbol="symbols.symbol_2" :volumeIsUndefined="volumeIsUndefined" />
  </div>
</template>

<script>
import symbolProgressComponent from "./symbol-progress.component.vue";
export default {
  components: { symbolProgressComponent },
  props: {
    symbols: {
      type: Object,
    },
    volumeIsUndefined: {
      type: Boolean,
    },
  },
};
</script>

<style></style>
